import * as types from "./types";
import { history } from '../../../history';
import { fetch } from "../../utils";
import {
  POST,
  DELETE,
  GET,
} from "../../../utilities/constants/globalconstants";
import { REJECTED } from "../../../utilities/constants/globalconstants";

import { displayError } from '../../../utilities/helpers/helper'

export function setActivePhases(phases) {
  return dispatch => {
    dispatch(setPhases({ phases }));
    localStorage.setItem('active-phases-name', phases.phaseName);
    localStorage.setItem('active-phases-uuid', phases.phaseUUID);
    history.push('/workflow/phase/stage');
  }

  function setPhases(phases) { return { type: types.ACTIVE_PHASE, phases } };
}

export const savePhase = (Phase) => async dispatch =>
  fetch(POST, "/hydra/phase", Phase)
    .then(res => dispatch(phaseSaveAction(res))).catch(displayError)

const phaseSaveAction = (payload) => ({ type: types.CREATE_PHASE, payload })

export const getAllPhase = () => async dispatch => {
  dispatch(setProject())
  fetch(GET, "/hydra/phase")
    .then(res => dispatch(phaseGetAction(res)))
    .catch(displayError)
}


const phaseGetAction = payload => ({ type: types.GET_ALL_PHASE, payload })

// maping

export const saveWorkflowPhase = phase => async dispatch =>
  fetch(POST, "/hydra/workflowphases", phase)
    .then(res => {
      dispatch(saveWorkflowPhaseAction(res))
    }).catch((error) => {
      console.error("workflowphases ", error)
    })

const saveWorkflowPhaseAction = payload => ({ type: types.CREATE_WORKFLOW_PHASE, payload })

export const getAllWorkflowPhase = (filterWith) => async dispatch => {
  dispatch(setProject())
  fetch(GET, "/hydra/workflowphases")
    .then((res) => {
      console.log("workflowphases ", res)
      dispatch(getWorkflowPhaseAction(filterPhases(res, filterWith)))
    }).catch((error) => {
      console.error("workflowphases ", error)
      dispatch(setError(error))
    })
}

const getWorkflowPhaseAction = payload => ({ type: types.GET_WORKFLOW_PHASE, payload })

function filterPhases(workflowphaseData, filterWith) {
  let filteredPhases = [];
  let activeWorkflow = ""
  if (filterWith === "dataview") {
    activeWorkflow = localStorage.getItem('selectedWorkflowId');
  } else {
    activeWorkflow = localStorage.getItem('active-workflow-uuid');
  }

  workflowphaseData.workflowPhasesMap.forEach(element => {
    if (activeWorkflow === element.workflowUUID) {
      filteredPhases.push(element);
    }
  });
  return filteredPhases;
}

export const deleteWorkflowPhase = (uuid) => async dispatch =>
  fetch(DELETE, "/hydra/workflowphases/" + uuid)
    .then(res => dispatch(deleteWorkflowPhaseAction(res))).catch((e) => console.log("Throws", e))

const deleteWorkflowPhaseAction = payload => ({ type: types.DELETE_WORKFLOW_PHASE, payload })

export const getPhaseComponentByWorkflow = (uuid) => async dispatch =>
  fetch(GET, "/hydra/phasecomponent?q=" + uuid)
    .then(res => dispatch(getWorkflowPhaseByWorkflowAction(res))).catch((e) => console.log("Throws", e))

const getWorkflowPhaseByWorkflowAction = payload => ({ type: types.GET_WORKFLOW_PHASE_BY_WORKFLOW, payload })

const setProject = () => ({
  type: types.SET_PROJECT
});

const setError = payload => ({
  type: types.GET_ALL_PHASE + REJECTED,
  payload
});
